module.exports = __webpack_public_path__ + "img/t.f2951bed.png";